/**
 * Polaris Chat Theme - Designer-specified theme for SimpleChatWidget.
 * 
 * This theme was provided by the design team specifically for the Polaris Chat
 * (xAI direct integration). It uses Open Sans typography and the "Candy" theme.
 * 
 * @see workspace/CU-868gzxrrg/research.md for implementation details
 */

export const polarisTheme = {
  // Typography - Open Sans
  fontBody: "375 16px/1.5 Open Sans",
  fontBodyLetterSpacing: "0px",
  fontBodyLink: "375 16px/1.5 Open Sans",
  fontBodyLinkLetterSpacing: "0px",
  fontBodyHeavy: "450 16px/1.5 Open Sans",
  fontBodyHeavyLetterSpacing: "0px",
  fontBodyMedium: "375 16px/1.5 Open Sans",
  fontBodyMediumLetterSpacing: "0px",
  fontBodySmallHeavy: "450 14px/1.5 Open Sans",
  fontBodySmallHeavyLetterSpacing: "0px",
  fontBodySmall: "375 14px/1.5 Open Sans",
  fontBodySmallLetterSpacing: "0px",
  fontBodyLarge: "375 18px/1.5 Open Sans",
  fontBodyLargeLetterSpacing: "0px",
  fontBodyLargeHeavy: "450 18px/1.5 Open Sans",
  fontBodyLargeHeavyLetterSpacing: "0px",
  
  // Label fonts
  fontLabel: "375 16px/1.2 Open Sans",
  fontLabelLetterSpacing: "0px",
  fontLabelHeavy: "450 16px/1.2 Open Sans",
  fontLabelHeavyLetterSpacing: "0px",
  fontLabelSmall: "375 14px/1.2 Open Sans",
  fontLabelSmallLetterSpacing: "0px",
  fontLabelSmallHeavy: "450 14px/1.2 Open Sans",
  fontLabelSmallHeavyLetterSpacing: "0px",
  fontLabelExtraSmall: "375 12px/1.2 Open Sans",
  fontLabelExtraSmallLetterSpacing: "0px",
  fontLabelExtraSmallHeavy: "450 12px/1.2 Open Sans",
  fontLabelExtraSmallHeavyLetterSpacing: "0px",
  fontLabelLarge: "375 18px/1.2 Open Sans",
  fontLabelLargeLetterSpacing: "0px",
  fontLabelLargeHeavy: "450 18px/1.2 Open Sans",
  fontLabelLargeHeavyLetterSpacing: "0px",
  fontLabelMediumHeavy: "450 16px/1.2 Open Sans",
  fontLabelMediumHeavyLetterSpacing: "0px",
  fontLabelMedium: "375 16px/1.2 Open Sans",
  fontLabelMediumLetterSpacing: "0px",
  
  // Heading fonts
  fontHeadingLarge: "550 28px/1.15 Open Sans",
  fontHeadingLargeLetterSpacing: "-0.25px",
  fontHeadingMedium: "550 24px/1.15 Open Sans",
  fontHeadingMediumLetterSpacing: "-0.25px",
  fontHeadingSmall: "550 18px/1.25 Open Sans",
  fontHeadingSmallLetterSpacing: "0px",
  fontHeadingExtraSmall: "550 16px/1.25 Open Sans",
  fontHeadingExtraSmallLetterSpacing: "0px",
  
  // Label2 fonts
  fontLabel2ExtraSmall: "375 12px/1.2 Open Sans",
  fontLabel2ExtraSmallLetterSpacing: "0px",
  fontLabel2ExtraSmallHeavy: "450 12px/1.2 Open Sans",
  fontLabel2ExtraSmallHeavyLetterSpacing: "0px",
  
  // Number fonts
  fontNumberLarge: "375 18px/1.5 Open Sans",
  fontNumberLargeLetterSpacing: "0px",
  fontNumberLargeHeavy: "450 18px/1.5 Open Sans",
  fontNumberLargeHeavyLetterSpacing: "0px",
  fontNumberHeavy: "450 16px/1.5 Open Sans",
  fontNumberHeavyLetterSpacing: "0px",
  fontNumber: "375 16px/1.5 Open Sans",
  fontNumberLetterSpacing: "0px",
  fontNumberSmall: "375 14px/1.5 Open Sans",
  fontNumberSmallLetterSpacing: "0px",
  fontNumberSmallHeavy: "450 14px/1.5 Open Sans",
  fontNumberSmallHeavyLetterSpacing: "0px",
  fontNumberExtraSmall: "375 12px/1.5 Open Sans",
  fontNumberExtraSmallLetterSpacing: "0px",
  fontNumberExtraSmallHeavy: "450 12px/1.5 Open Sans",
  fontNumberExtraSmallHeavyLetterSpacing: "0px",
  fontNumberTitle: "550 28px/1.5 Open Sans",
  fontNumberTitleLetterSpacing: "0px",
  fontNumberTitleMedium: "550 24px/1.5 Open Sans",
  fontNumberTitleMediumLetterSpacing: "0px",
  
  // Background fills
  backgroundFills: "#F1F1F1",
  containerFills: "#FFFFFF",
  overlayFills: "rgba(0, 0, 0, 0.5)",
  sunkFills: "rgba(0, 0, 0, 0.04)",
  containerHoverFills: "rgba(0, 0, 0, 0.04)",
  dangerFills: "#FFF0F0",
  successFills: "#EBFFE7",
  infoFills: "#F0F3FF",
  elevatedFills: "rgba(255, 255, 255, 0.2)",
  alertFills: "#FFF8F4",
  sunkBgFills: "rgba(0, 0, 0, 0.04)",
  invertedFills: "#101010",
  
  // Strokes
  strokeDefault: "rgba(0, 0, 0, 0.06)",
  strokeInteractiveEl: "rgba(0, 0, 0, 0.1)",
  strokeInteractiveElHover: "rgba(0, 0, 0, 0.3)",
  strokeInteractiveElSelected: "rgba(0, 0, 0, 0.5)",
  strokeEmphasis: "rgba(0, 0, 0, 0.2)",
  strokeAccent: "rgba(255, 255, 255, 0.04)",
  strokeAccentEmphasis: "rgba(255, 255, 255, 0.08)",
  strokeInfo: "#E7EEFF",
  strokeInfoEmphasis: "#0084F4",
  strokeAlert: "#FFF1E4",
  strokeAlertEmphasis: "#EFA51B",
  strokeSuccess: "#D3FFD1",
  strokeSuccessEmphasis: "#50AE60",
  strokeDanger: "#FFE9E9",
  strokeDangerEmphasis: "#EC4565",
  
  // Text colors
  brandText: "rgba(255, 255, 255, 1)",
  brandSecondaryText: "rgba(255, 255, 255, 0.7)",
  primaryText: "#1B1B1B",
  secondaryText: "#717171",
  disabledText: "#AFAFAF",
  dangerText: "#A8123B",
  successText: "#067B31",
  linkText: "#81450A",
  infoText: "#0055A0",
  accentPrimaryText: "rgba(255, 255, 255, 1)",
  accentSecondaryText: "rgba(255, 255, 255, 0.7)",
  accentDisabledText: "rgba(255, 255, 255, 0.4)",
  successPrimaryText: "rgba(40, 140, 80, 1)",
  successInvertedText: "rgba(200, 255, 220, 1)",
  alertPrimaryText: "rgba(180, 130, 0, 1)",
  alertInvertedText: "rgba(255, 240, 180, 1)",
  dangerPrimaryText: "rgba(180, 40, 50, 1)",
  dangerSecondaryText: "rgba(200, 60, 70, 1)",
  dangerDisabledText: "rgba(220, 160, 165, 1)",
  dangerInvertedPrimaryText: "rgba(255, 255, 255, 1)",
  dangerInvertedSecondaryText: "rgba(255, 255, 255, 0.7)",
  dangerInvertedDisabledText: "rgba(255, 255, 255, 0.4)",
  infoPrimaryText: "rgba(60, 100, 160, 1)",
  infoInvertedText: "rgba(200, 225, 255, 1)",
  
  // Interactive colors
  interactiveDefault: "rgba(255, 255, 255, 0.02)",
  interactiveHover: "rgba(0, 0, 0, 0.04)",
  interactivePressed: "rgba(0, 0, 0, 0.06)",
  interactiveDisabled: "rgba(255, 255, 255, 0.02)",
  interactiveAccent: "#F19649",
  interactiveAccentHover: "#CD803E",
  interactiveAccentPressed: "#A96933",
  interactiveAccentDisabled: "#F7C59B",
  interactiveDestructive: "#FFF0F0",
  interactiveDestructiveHover: "#FFE9E9",
  interactiveDestructivePressed: "#FFDDDF",
  interactiveDestructiveDisabled: "#FFF0F0",
  
  // Highlight
  highlightSubtle: "rgba(0, 0, 0, 0.02)",
  
  // Chat-specific colors (key values for SimpleChatWidget)
  chatContainerBg: "#F1F1F1",
  chatAssistantResponseBg: "#FFFFFF",
  chatAssistantResponseText: "#1B1B1B",
  chatUserResponseBg: "#D6D6D6",
  chatUserResponseText: "#242424",
  
  // Chart palette
  defaultChartPalette: [
    "#FCE5D2",
    "#F9D5B6",
    "#F7C59B",
    "#F5B680",
    "#F19649",
    "#CD803E",
    "#A96933",
    "#855328",
    "#603C1D"
  ],
  
  // Spacing
  spacing0: "0px",
  spacing3xs: "2px",
  spacing2xs: "4px",
  spacingXs: "6px",
  spacingS: "8px",
  spacingM: "12px",
  spacingL: "18px",
  spacingXl: "24px",
  spacing2xl: "36px",
  spacing3xl: "48px",
  
  // Border radius
  rounded0: "0px",
  rounded3xs: "1px",
  rounded2xs: "2px",
  roundedXs: "3px",
  roundedS: "4px",
  roundedM: "6px",
  roundedL: "8px",
  roundedXl: "10px",
  rounded2xl: "12px",
  rounded3xl: "14px",
  rounded4xl: "16px",
  roundedFull: "999px",
  roundedClickable: "6px",
  
  // Shadows
  shadowS: "0px 1px 2px rgba(0, 0, 0, 0.04)",
  shadowM: "0px 4px 6px rgba(0, 0, 0, 0.04)",
  shadowL: "0px 1px 8px rgba(0, 0, 0, 0.08)",
  shadowXl: "0px 10px 15px rgba(0, 0, 0, 0.1)",
  
  // Theme metadata
  mode: "Light" as const,
  name: "Candy",
  typography: "Open Sans",
} as const;

// Type for the theme
export type PolarisTheme = typeof polarisTheme;

// Helper to get commonly used values
export const polarisChatStyles = {
  // Container
  containerBg: polarisTheme.chatContainerBg,
  
  // Message bubbles
  assistantBubble: {
    backgroundColor: polarisTheme.chatAssistantResponseBg,
    color: polarisTheme.chatAssistantResponseText,
    borderRadius: polarisTheme.rounded2xl, // 12px
    boxShadow: polarisTheme.shadowS,
    padding: polarisTheme.spacingM, // 12px
  },
  userBubble: {
    backgroundColor: polarisTheme.chatUserResponseBg,
    color: polarisTheme.chatUserResponseText,
    borderRadius: polarisTheme.rounded2xl, // 12px
    boxShadow: polarisTheme.shadowS,
    padding: polarisTheme.spacingM, // 12px
  },
  
  // Input area
  input: {
    backgroundColor: polarisTheme.containerFills,
    borderRadius: polarisTheme.roundedL, // 8px
    borderColor: polarisTheme.strokeInteractiveEl,
  },
  
  // Send button
  sendButton: {
    backgroundColor: polarisTheme.interactiveAccent,
    hoverColor: polarisTheme.interactiveAccentHover,
    pressedColor: polarisTheme.interactiveAccentPressed,
    disabledColor: polarisTheme.interactiveAccentDisabled,
    borderRadius: polarisTheme.roundedClickable, // 6px
  },
  
  // Typography
  fontFamily: "'Open Sans', sans-serif",
  bodyFont: polarisTheme.fontBody,
  headingFont: polarisTheme.fontHeadingSmall,
  
  // Spacing
  messageGap: polarisTheme.spacingM, // 12px
  containerPadding: polarisTheme.spacingL, // 18px
};
